
<input
  type="radio"
  :name="radioName"
  :checked="radioValue == value"
  :value="radioValue"
  v-on:change="$emit('change', $event.target.value)"
/>
